<template>
  <section class="etc-h5">
    <img src="../../assets/some/etc-h5-bg.jpg" alt="" class="bg">
    <img src="../../assets/some/etc-h5-code.png" alt="" class="code">
  </section>
</template>

<script>
// mixins
import FunMixin from '@/mixins/funMixin'

export default {
  name: 'etcH5',
  mixins: [FunMixin],
  components: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  created() {
  }
}
</script>

<style scoped lang="scss">
.etc-h5{
  background-color: #23254b;
  position: relative;
  font-size: 0;
  .bg{
    width: 100%;
  }
  .code{
    position: absolute;
    right: 77px;
    top: 760px;
    width: 330px;
    height: 330px;
    border-radius: 40%;
  }
}
</style>
